import { render, staticRenderFns } from "./ImportacaoDetalheModal.vue?vue&type=template&id=d35c2dc4&scoped=true"
import script from "./ImportacaoDetalheModal.vue?vue&type=script&lang=ts"
export * from "./ImportacaoDetalheModal.vue?vue&type=script&lang=ts"
import style0 from "./ImportacaoDetalheModal.vue?vue&type=style&index=0&id=d35c2dc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d35c2dc4",
  null
  
)

export default component.exports